/*
  np-sale-display.js — storefront-only 50% sale price display
  Toggle: Theme settings → NattyPLUS — Sale display
*/
(function (w) {
  var SD = {
    enabled: false,
    pct: 50,
    init: function (cfg) {
      cfg = cfg || {};
      this.enabled = !!cfg.enabled;
      this.pct = cfg.pct || 50;
      if (this.enabled && w.document && w.document.documentElement) {
        w.document.documentElement.classList.add('np-sale-display-half');
      }
    },
    adjustCents: function (cents) {
      var c = Math.round(cents || 0);
      return this.enabled ? Math.round(c / 2) : c;
    },
    displayPct: function (compareCents, saleCents, calculatedPct) {
      if (this.enabled && compareCents > 0 && compareCents > saleCents) return this.pct;
      if (calculatedPct != null) return calculatedPct;
      if (compareCents > 0 && saleCents < compareCents) {
        return Math.round(((compareCents - saleCents) / compareCents) * 100);
      }
      return 0;
    },
    hasSale: function (compareCents, saleCents) {
      return compareCents > this.adjustCents(saleCents);
    },
  };
  w.NPSaleDisplay = SD;
})(window);
